let ppp = 3; // Post per page
let pageNumber = 1;

jQuery(function($){
    $('#load_more_posts').on('click', function(e) {
        e.preventDefault();
		let dataCount = $("#load_more_posts").data('post-count');
		if (dataCount) ppp = dataCount;
        $("#load_more_posts").attr("disabled",true);
        pageNumber++;
	    let str = '&pageNumber=' + pageNumber + '&ppp=' + ppp + '&action=load_more_posts';
        $.ajax({
            method: "POST",
	        type: 'JSON',
	        url: ajax_object.ajax_url,
	        data: str,
            success:function(response) {
        		if(response.length) {
	                $('#blog-main-container').append(response);
	                $("#load_more_posts").attr("disabled",false);
	                postsVisible = parseInt(postsVisible) + ppp;
	                addImgBg('.js-img-bg');
	            }

	            if (postsVisible >= postsFound) {
	            	$(".blog-main__load-more-container").hide();
	            }
            }
        }); 
    })
});
